export default [
  {
    title: 'GENERAL INFORMATION ABOUT OUR COLLECTION AND USE OF PERSONAL INFORMATION',
    text1: 'When we refer to “personal information” in this Policy, we mean information that identifies, relates to, describes, or is reasonably capable of being associated with, or could reasonably be linked, directly or indirectly, to a particular individual. Please note that “personal information” does not include publicly available information from government records or information that has been deidentified or aggregated so it cannot be used to identify a specific individual (“Deidentified Data”).' +
      '<br><br>We are committed to maintaining Deidentified Data in its deidentified form and will not attempt to reidentify it, except for the sole purpose of determining whether our deidentification processes meet the requirements of applicable laws.' +
      '<br><br>Our primary goals in collecting personal information are to provide and enhance our Online Offerings, conduct our business operations, offer our Services, communicate with you, and ensure visitors to our Online Offerings have a seamless and enjoyable experience.' +
      '<br><br>The categories of personal information we collect and use in connection with our Services may fall into one or more of the following categories. Please note that the examples provided for each category are not a representation that we will collect that specific type of personal information about you.',
    uls: [
      {
        points: [
          {text: '<strong>Identifiers:</strong> Such as real name, alias, postal address, unique personal identifier, online identifier, internet protocol address, email address, account name, social security number, driver\'s license number, passport number, or other similar identifiers.'},
          {text: '<strong>Customer Records:</strong> Such as name, signature, social security number, physical characteristics or description, address, telephone number, passport number, driver’s license or state identification card number, bank account number, credit card number, debit card number,crypto wallet address, or any other financial information.'},
          {text: '<strong>Commercial Information:</strong> Including records of products or services purchased, obtained, or considered, or other purchasing or consuming histories or tendencies.'},
          {text: 'Geolocation Data.'},
          {text: 'Audio, Electronic, Visual, or Similar Information.'},
        ]
      }
    ],
    text2: 'Depending on how you use our Services or interact with us, the following table provides a summary of the categories of personal information we may collect, the sources from which the personal information is collected, our business or commercial purposes for collecting the information, and the categories of third parties to whom we may disclose such information.'
  },
  {
    title: 'SOURCES OF PERSONAL INFORMATION',
    ols: [
      {
        points: [
          {
            title: '<strong>Directly from Individuals or Generated by Their Use of the Services</strong>',
            uls: [
              {
                noBullet: true,
                title: '<strong>Categories of Personal Information Collected:</strong>',
                points: [
                  {text: 'Identifiers'},
                  {text: 'Customer Records'},
                ]
              },
              {
                noBullet: true,
                title: '<strong>Business or Commercial Purposes for Collecting Personal Information:</strong>',
                points: [
                  {text: 'Provide the Services'},
                  {text: 'Assess and improve the Services'},
                  {text: 'Track usage of the Services'},
                  {text: 'Create and update customer profiles'},
                  {text: 'Determine eligibility for offers'},
                  {text: 'Internal market research and analytics'},
                  {text: 'Provide notifications about promotions and special offers'},
                  {text: 'Generate statistical studies'},
                  {text: 'Ensure fairness, security, and safety of the Services'},
                  {text: 'Protect our rights and property'},
                  {text: 'Respond to inquiries'},
                  {text: 'Perform background checks'},
                  {text: 'Process financial transactions'},
                  {text: 'Responsible gambling assessments'},
                  {text: 'Predict preferences, interests, and future gaming and spending activities'},
                ]
              },
              {
                noBullet: true,
                title: '<strong>Third Parties with Whom Personal Information May be Disclosed:</strong>',
                points: [
                  {text: 'Third-party service providers'},
                  {text: 'Third-party business partners'},
                  {text: 'Government agencies and related entities'},
                  {text: 'Credit reporting agencies'},
                  {text: 'Data analytics providers'},
                ]
              }
            ]
          },
          {
            title: '<strong>Automatically through Our Online Offerings</strong>',
            uls: [
              {
                noBullet: true,
                title: '<strong>Categories of Personal Information Collected:</strong>',
                points: [
                  {text: 'Identifiers'},
                  {text: 'Internet or Other Electronic Network Activity Information'},
                  {text: 'Geolocation Data'},
                  {text: 'Inferences'},
                ]
              },
              {
                noBullet: true,
                title: '<strong>Business or Commercial Purposes for Collecting Personal Information:</strong>',
                points: [
                  {text: 'Provide the Services'},
                  {text: 'Assess and improve the Services'},
                  {text: 'Track usage of the Services'},
                  {text: 'Create and update customer profiles'},
                  {text: 'Internal market research and analytics'},
                  {text: 'Protect our rights and property'},
                  {text: 'Ensure the fairness, security, and safety of the Services'},
                  {text: 'Detect security incidents'},
                  {text: 'Responsible gambling assessments'},
                  {text: 'Predict preferences, interests, and future gaming and spending activities'},
                ]
              },
              {
                noBullet: true,
                title: '<strong>Third Parties with Whom Personal Information May be Disclosed:</strong>',
                points: [
                  {text: 'Third-party service providers'},
                  {text: 'Third-party business partners'},
                  {text: 'Government agencies and related entities'},
                  {text: 'Credit reporting agencies'},
                  {text: 'Data analytics providers'},
                ]
              }
            ]
          },
          {
            title: '<strong>From Third-Party Service Providers, Business Partners, Government Agencies, and Related Entities</strong>',
            uls: [
              {
                noBullet: true,
                title: '<strong>Categories of Personal Information Collected:</strong>',
                points: [
                  {text: 'Identifiers'},
                  {text: 'Customer Records'},
                  {text: 'Legally Protected Characteristics'},
                  {text: 'Commercial Information'},
                  {text: 'Geolocation Data'},
                  {text: 'Audio, Electronic, Visual or Similar Information'},
                  {text: 'Inferences'},
                ]
              },
              {
                noBullet: true,
                title: '<strong>Business or Commercial Purposes for Collecting Personal Information:</strong>',
                points: [
                  {text: 'Provide the Services'},
                  {text: 'Assess and improve the Services'},
                  {text: 'Track usage of the Services'},
                  {text: 'Create and update customer profiles'},
                  {text: 'Internal market research and analytics'},
                  {text: 'Generate statistical studies'},
                  {text: 'Ensure the fairness, security, and safety of our Services'},
                  {text: 'Protect our rights and property'},
                  {text: 'Respond to inquiries'},
                  {text: 'Perform background checks'},
                  {text: 'Process financial transactions'},
                  {text: 'Detect security incidents'},
                  {text: 'Responsible gambling assessments'},
                  {text: 'Predict preferences, interests, and future gaming and spending activities'},
                ]
              },
              {
                noBullet: true,
                title: '<strong>Third Parties with Whom Personal Information May be Disclosed:</strong>',
                points: [
                  {text: 'Third-party service providers'},
                  {text: 'Third-party business partners'},
                  {text: 'Government agencies and related entities'},
                  {text: 'Credit reporting agencies'},
                  {text: 'Data analytics providers'},
                ]
              }
            ]
          },
        ]
      }
    ]
  },
  {
    title: 'INFORMATION WE MAY COLLECT',
    text1: 'At MaxQuest, we may collect the following information from you:',
    uls: [
      {
        points: [
          {text: 'Full Name: Your complete name as provided during registration.'},
          {text: 'Date of Birth: Your birth date to verify age and eligibility.'},
          {text: 'Permanent Address: Your home address for verification and correspondence.'},
          {text: 'Email: Your email address for communication and account management.'},
          {text: 'Phone Number: Your contact number for communication and security purposes.'},
          {
            text: 'Device Information: Details about your device and how you use our website, including:',
            points: [
              {text: 'The content you view'},
              {text: 'The time and duration of your visit'},
              {text: 'Frequency of your use'},
              {text: 'How you first heard about our website'},
              {text: 'Your preferences and interactions with our content'},
              {text: 'Hardware model, device type, unique device identifiers'},
              {text: 'Operating system version, browser type, and IP address'},
            ]
          },
          {text: 'Identification Documents: Such as ID, utility bills, bank statements, etc., for verification purposes.'},
          {text: 'Transaction Information: Linked to the purchases and redemptions you make on our platform.'},
          {text: 'Communications: Records of interactions with our teams, including support inquiries, live chats, and complaints.'},
          {text: 'Third-Party Information: Data we receive from third parties (e.g., social media platforms like Facebook) about your use of or interest in our services.'},
        ]
      }
    ]
  },
  {
    title: 'HOW WE USE THE INFORMATION WE COLLECT AND OPT-OUT OPTIONS',
    olType: 'A',
    ols: [
      {
        points: [
          {
            title: 'Use by MaxQuest<br><br>',
            text1: '<strong>Marketing Purposes:</strong> We may use the information we collect for our marketing purposes, ' +
              'including notifying you of special promotions, offers, and events via push notifications, ' +
              'email, and other means. We may also link personal information (including your name, mobile ' +
              'phone number, and email address) with non-personal information (including information collected ' +
              'through Tracking Technologies and Wi-Fi services) and use such information for our marketing ' +
              'efforts. If you do not want us to use your personal information for marketing purposes, you ' +
              'may opt-out as described in the “How to Opt-Out” section below.' +
              '<br><br><strong>Non-Marketing Purposes:</strong> We may use the information we collect for non-marketing purposes, including:',
            ols: [
              {
                points: [
                  {text: 'Validating your identity.\n'},
                  {text: 'Providing and facilitating our Online Offerings.'},
                  {text: 'Sending you push notifications or emails to provide you with alerts and updates about your Account and the Services.'},
                  {text: 'Monitoring, accessing, and recording gaming-related activity.'},
                  {text: 'Conducting statistical or demographic analysis.'},
                  {text: 'Processing and tracking gaming and non-gaming transactions.'},
                  {text: 'Complying with legal and regulatory requirements, including responding to subpoenas, search warrants, and other inquiries from our regulators.'},
                  {text: 'Customizing your experience with the Services.'},
                  {text: 'Protecting and defending MaxQuest against legal actions or claims.'},
                  {text: 'Preventing fraud.'},
                  {text: 'Debt collection.'},
                  {text: 'Satisfying contractual obligations.'},
                  {text: 'Conducting responsible gambling assessments.'},
                  {text: 'Responding to Customer Care requests.'},
                  {text: 'Ensuring safety, security, and fairness, including cooperating with law enforcement or other government agencies for national security, public safety, or matters of public importance when we believe that disclosure of information is necessary or appropriate to protect the public interest.'},
                ]
              }
            ],
            text2: '<strong>Text Messages:</strong> If you have provided us with your consent to receive communications via ' +
              'phone calls or text messages, we may use your information to send text messages to any mobile ' +
              'device connected to your cell phone number. You may opt-out from marketing text messages by ' +
              'replying STOP to any marketing text messages you receive from us. Once you cancel, we may send ' +
              'one additional confirmation text message stating that you have opted out of receiving marketing ' +
              'text messages from us.' +
              '<br><br> Please note that certain transactional text messages, including those related to account ' +
              'security, are not subject to opt-out.'
          },
          {
            title: 'Sharing with Affiliates<br><br>',
            text1: 'MaxQuest may share the information we collect with our affiliates for both marketing and non-marketing purposes. If you prefer that we do not share your personal information with our affiliates for marketing purposes, you can opt-out as detailed in the “How to Opt-Out” section below.'
          },
          {
            title: 'Sharing with Business Partners and Other Third Parties<br><br>',
            text1: 'We may share your information with our business partners ' +
              'and other third parties for joint marketing purposes or for the ' +
              'business partners\' own marketing purposes. If our operation in ' +
              'a jurisdiction is based on a relationship with a third party ' +
              '(“Market Access Partner”), we may be required to share information ' +
              'with that third party for both marketing and non-marketing purposes. ' +
              'Even if you opt-out of sharing your personal information with our' +
              ' business partners for marketing purposes, we may still share it for ' +
              'non-marketing purposes such as processing transactions, fulfilling ' +
              'your requests, and responding to inquiries.' +
              '<br><br>For example, if you are referred to MaxQuest by one of our partners, we may share certain information related to your gaming activity with that partner for their business purposes, including marketing.'
          },
          {
            title: 'Service Providers<br><br>',
            text1: 'We engage service providers to assist with various services such as analytics, marketing, and fulfillment. These service providers may collect or be provided with access to your information as necessary to perform their services, under the condition that they do not use or disclose your personal information for other purposes.'
          },
          {
            title: 'Fraud Prevention and Security<br><br>',
            text1: 'MaxQuest is committed to ensuring the fairness, security, and safety of our platform. We share information with our affiliates, service providers, state regulators, government agencies, sports governing bodies, and other similar third parties to detect, prevent, and report fraud, unsafe gambling, and other unethical or illegal activities.'
          },
          {
            title: 'Certain Business Transactions<br><br>',
            text1: 'In the event of a business transaction involving a sale, purchase, reorganization, merger, or transfer of MaxQuest’s assets or those of our affiliates, we may share all collected information with the successor to our business.'
          },
          {
            title: 'How to Opt-Out of Marketing from Us and How to Opt-Out of Having Your Personal Information Shared with Others for Marketing Purposes<br><br>',
            text1: 'If you wish to opt-out of receiving marketing communications from MaxQuest via email or SMS or ' +
              'if you do not want us to share your personal information for marketing purposes with our business ' +
              'partners, third parties, or affiliates, please contact Support.' +
              '<br><br>You can also unsubscribe from receiving marketing SMS messages by replying STOP to any ' +
              'marketing text message you receive from MaxQuest.' +
              '<br><br>Please note that even if you opt-out of ' +
              'the use and sharing of personal information for marketing purposes, we may still use and share' +
              ' information we collect for non-marketing purposes.'
          },
          {
            title: 'Your Consent or Instructions<br><br>',
            text1: 'We may share your personal information with any third party to whom you consent or instruct us to provide your personal information.'
          },
          {
            title: 'No Additional Disclosures<br><br>',
            text1: 'We will not share the information we collect with third parties, other than as described in this Policy. Any information that we collect that we do not disclose to third parties as described in this Policy will be kept confidential, except where the release of that information is required by law.'
          }
        ]
      }
    ]
  },
  {
    title: 'HOW LONG WE KEEP YOUR PERSONAL INFORMATION',
    text1: 'The duration for which MaxQuest retains personal information depends on why it was collected, how we use it in our operations, and any applicable legal requirements. We may retain personal information to:',
    uls: [
      {
        points: [
          {text: 'Complete the transaction for which the personal information was collected,'},
          {text: 'Maintain our ongoing business relationship with you,'},
          {text: 'Ensure the security and integrity of our services, and'},
          {text: 'Comply with legal, regulatory, tax, accounting, or reporting obligations.'},
        ]
      }
    ],
    text2: 'To determine the appropriate retention period for different categories of personal information, we ' +
      'consider the nature and sensitivity of the information, the potential risk of harm from unauthorized use ' +
      'or disclosure, the purposes for which we process the information and whether we can achieve those ' +
      'purposes through other means, and relevant legal, regulatory, tax, accounting, ' +
      'reporting, or other requirements.' +
      '<br><br>Once we determine that we no longer need to retain specific personal information, we will securely erase it from all storage media, or we will aggregate, anonymize, or de-identify the information so that it no longer identifies you, in accordance with applicable laws.'
  },
  {
    title: 'STATE SPECIFIC RIGHTS',
    text1: 'This section describes the rights certain states provide residents of those states with respect to their personal information (“State Privacy Rights”). Please note, if you are not a resident of any state described below, the rights described for such states do not apply to you, but many of these options are available via your account settings when logged into our Services, or through our Customer Care team.',
    uls: [
      {
        title: '<strong>California</strong><br><br>',
        subtitle: 'The California Consumer Privacy Act of 2018 as amended (collectively, “CCPA”) grants certain privacy rights to California consumers, including the right to:',
        points: [
          {text: 'Know what categories of personal information we have collected about California consumers during the preceding 12 months, including the categories of sources from which that information was collected, the business or commercial purpose for which it was collected, and the categories of third parties with whom the information was shared;'},
          {text: 'Request to know what personal information we have collected, used, disclosed, and sold about you during the preceding 12 months;'},
          {text: 'Request that we delete your personal information;'},
          {text: 'Opt-out of the sale of your personal information to third parties.'},
        ]
      },
      {
        title: '<strong>Colorado</strong><br><br>',
        subtitle: 'The Colorado Privacy Act and its regulations (“CPA”) grant certain privacy rights to Colorado consumers, including the right to:',
        points: [
          {text: 'Opt-out of the processing of personal information concerning targeted advertising, the sale of personal information, or profiling in furtherance of decisions that produce legal or similarly significant effects concerning a consumer;'},
          {text: 'Access the consumer’s personal information, in a portable manner;'},
          {text: 'Correct inaccuracies in the consumer’s personal information;'},
          {text: 'Request the deletion of personal information held regarding the consumer.'},
        ]
      },
      {
        title: '<strong>Connecticut</strong><br><br>',
        subtitle: 'The Connecticut Data Privacy Act (“CTDPA”) grants certain privacy rights to Connecticut consumers, including the right to:',
        points: [
          {text: 'Request to confirm whether we are processing your personal information and to access that personal information;'},
          {text: 'Request that we delete your personal information;'},
          {text: 'Request to correct your inaccurate personal information;'},
          {text: 'Request to obtain a portable copy of your personal information;'},
          {text: 'Opt-out of the processing of your personal information for certain purposes;'},
          {text: 'Appeal any adverse decision we make regarding your request to exercise your privacy rights.'},
        ]
      },
      {
        title: '<strong>Virginia</strong><br><br>',
        subtitle: 'The Virginia Consumer Data Protection Act (“VCDPA”) grants certain privacy rights to Virginia consumers, including the right to:',
        points: [
          {text: 'Request to confirm whether we are processing your personal information and to access that personal information;'},
          {text: 'Request that we delete your personal information;'},
          {text: 'Request to correct your inaccurate personal information;'},
          {text: 'Request to obtain a portable copy of your personal information;'},
          {text: 'Opt-out of the processing of your personal information for certain purposes;'},
          {text: 'Appeal any adverse decision we make regarding your request to exercise your privacy rights.'},
        ]
      },
      {
        title: '<strong>Access Requests</strong><br><br>',
        subtitle: 'At MaxQuest, you have the right to request access to your personal information for the 12-month period prior to the date of your request. Specifically, you can ask us to disclose:',
        points: [
          {text: 'The categories of personal information we have collected about you.'},
          {text: 'The categories of sources from which your personal information was collected.'},
          {text: 'The business or commercial purpose for collecting or selling your personal information.'},
          {text: 'The categories of third parties with whom we have shared or sold your personal information.'},
        ],
        text1: 'Additionally, you can request to see the specific pieces of personal information we hold about you. All access requests require verification of your identity to ensure your information is protected.'
      },
      {
        title: '<strong>Deletion Requests</strong><br><br>',
        subtitle: 'You have the right to request the deletion of your personal information from MaxQuest, ' +
          'with certain exceptions. These exceptions include situations where we need to comply with legal ' +
          'obligations, fulfill orders, complete transactions, or other similar reasons. All deletion ' +
          'requests require verification of your identity.' +
          '<br><br>Please note that while we strive to honor deletion requests, certain exceptions may apply, such as state data retention requirements. If your request is verified and we delete your personal information, we will also instruct any service providers to delete your information from their records, in accordance with applicable legal requirements.'
      },
      {
        title: '<strong>Correction Requests</strong><br><br>',
        subtitle: 'At MaxQuest, you have the right to request the correction of any inaccurate personal information we hold about you. If you believe your information is incorrect, you can ask us to correct it, and we will use commercially reasonable efforts to do so. We may ask you to provide documentation to verify the inaccuracies in the information we have retained.'
      },
      {
        title: '<strong>Requests to Opt-Out of Sale or Sharing</strong><br><br>',
        subtitle: 'You have the right to opt-out of having your personal information sold or shared with third ' +
          'parties for targeted advertising purposes. While MaxQuest does not sell your personal information in ' +
          'the traditional sense (i.e., we do not exchange your name, phone number, address, email address, or ' +
          'other personally identifiable information for money), certain sharing of information for advertising ' +
          'purposes may be considered a "sale" under California law. MaxQuest uses cookies for targeted ' +
          'advertising in some jurisdictions.' +
          '<br><br>Even if you opt-out of the sale or sharing of your personal information, please note that we may still:',
        points: [
          {text: 'Share your personal information with service providers and other entities for business purposes, consistent with state privacy laws.'},
          {text: 'Share your personal information in connection with certain business transactions.'},
        ],
        text1: '<br><br>Please note that opting out of the sale or sharing of your personal information does not prevent us from:<br><br>',
        otherPoints: [
          {text: 'Sharing your personal information with service providers and other entities for business purposes, consistent with state privacy laws and our legal and regulatory obligations.'},
          {text: 'Sharing your personal information in connection with certain business transactions, as outlined above.'},
        ]
      },
      {
        title: '<strong>Right to Appeal</strong><br><br>',
        subtitle: 'If you disagree with our refusal to act on your request to exercise your State Privacy Rights, you have the right to request reconsideration. Appeal requests should be submitted by directly responding to our denial of your privacy request through our online portal. You must submit your request within 60 days of receiving our denial. Once we receive your appeal, we will acknowledge it and begin processing. Within 45 days of receiving your appeal, we will inform you in writing of any action taken or not taken in response, including an explanation of the reasons for our decision. If you are not satisfied with the outcome, you may contact your applicable regulator to submit a complaint. State-specific appeal information is listed in the “Other State-Specific Privacy Rights” section below.',
      },
      {
        title: '<strong>Non-Discrimination</strong><br><br>',
        subtitle: 'MaxQuest will not discriminate against you for exercising any of your State Privacy Rights. Unless permitted by state privacy laws, if you exercise your rights under state privacy laws, we will not:',
        points: [
          {text: 'Deny you goods or services,'},
          {text: 'Charge you different prices or rates for goods or services, including granting discounts or other benefits or imposing penalties,'},
          {text: 'Provide you with a different level or quality of goods or services, or'},
          {text: 'Suggest that you may receive a different price or rate for goods or services or a different level of quality of goods or services.'},
        ],
        text1: 'However, we may offer, survey rewards, and sweepstakes or contest rewards (“Promotions”) from time to time. In exchange, we will collect, use, share, and retain certain personal information from you to implement the Promotions. We will also maintain and utilize the personal information you provide for future marketing purposes. These financial incentives are reasonably related to the value of the personal information you provide.'
      },
      {
        title: 'Additional Uses or Disclosures of Sensitive Personal Information <br><br>',
        subtitle: 'MaxQuest does not use or disclose sensitive personal information for any purpose other than our own business purposes, as specified under CCPA.'
      }
    ]
  },
  {
    title: 'HOW TO SUBMIT A PRIVACY REQUEST',
    text1: 'If your state grants you these rights and you wish to submit a privacy request, ' +
      'please contact us via Live Help or Discord and provide the requested identifying ' +
      'information. All requests are subject to verification of your identity to ensure ' +
      'the privacy and security of your personal information. We are required to fulfill ' +
      'these requests no more than twice within a 12-month period.' +
      '<br><br>You may only make a request on behalf of yourself. If you are a California resident, ' +
      'an authorized person acting on your behalf may make a request related to your personal information.' +
      '<br><br><strong>Requests to Opt-Out of Sale or Sharing:</strong>' +
      '<br><br>In addition to submitting a request as noted above, you must access the MaxQuest Cookie Settings page and turn off Targeting Cookies (or broadcast the Global Privacy Control (“GPC”) signal) to fully exercise your sale or sharing opt-out rights. The cookie preference tool is device and browser-specific. If you delete or clear cookies or change devices or browsers, you will need to reset your cookie preferences using the tool. Please note that even if you opt-out of the sale or sharing of your personal information, we may still disclose your personal information to service providers, contractors, and other entities for business or commercial purposes consistent with state law and in certain business transactions with our service providers.'
  },
  {
    title: 'VERIFICATION PROCEDURES',
    text1: 'To verify your State Privacy Rights requests, we may require two or more pieces of identifying ' +
      'information that match the information we have on file. If you have an account with MaxQuest, we may ' +
      'verify your identity through your account. In some cases, additional identifying information and a ' +
      'signed declaration attesting to your identity may be required. If we receive a request from an authorized ' +
      'agent on your behalf, we may ask for written proof that the agent is authorized to act on your behalf ' +
      'and take additional steps to verify both your identity and the agent\'s identity. Requests to opt-out ' +
      'do not need to be verified. However, if we believe an opt-out request is fraudulent, we may deny it ' +
      'and explain the reason.<br><br>In certain circumstances, we may decline a request if we are unable to verify ' +
      'your identity or are required to retain the information by law. If we cannot comply with ' +
      'your request, we will explain why.' +
      '<br><br><strong>California’s Shine the Light Law</strong>:' +
      '<br><br>Under California’s Shine the Light law, businesses ' +
      'must respond to requests from California residents about the disclosure of personal information ' +
      'to third parties for marketing purposes. Alternatively, businesses can adopt a policy of not ' +
      'disclosing personal information to third parties for marketing purposes if a California resident ' +
      'has opted-out. We have adopted an opt-out policy. If you wish to opt-out of our sharing your ' +
      'personal information with third parties for marketing purposes, please contact support.[contact support link]' +
      '<br><br><strong>California Sensitive Information:</strong>' +
      '<br><br>You have the right to request that we limit our use or disclosure of Sensitive Personal Information ' +
      '(as defined by California law) to specific uses authorized by the CCPA. We do not disclose Sensitive ' +
      'Personal Information beyond these authorizations.' +
      '<br><br><strong>Nevada Do Not Sell:</strong>' +
      '<br><br>Nevada law gives consumers the right to restrict certain businesses from selling personal ' +
      'information to unaffiliated third parties. MaxQuest does not sell the personal information of ' +
      'Nevada consumers as defined by Nevada law. If you are a Nevada resident and wish to restrict ' +
      'any such sales in the future, please contact us and provide your complete name, street address, ' +
      'city, state, zip code, and email address.' +
      '<br><br><strong>Virginia Appeal Rights:</strong>' +
      '<br><br>If you are a Virginia resident and your privacy request appeal is denied, you ' +
      'may submit a complaint to the Virginia Attorney General.' +
      '<br><br><strong>Colorado Appeal Rights:</strong>' +
      '<br><br>If you are a Colorado resident and have concerns about your privacy appeal, you may submit a complaint to the Colorado Attorney General.'
  },
  {
    title: 'DATA STORAGE AND SECURITY',
    text1: 'At MaxQuest, we store non-gaming information and non-live gaming data collected through our ' +
      'services on secure servers located in the United States. Internet wagering and live gameplay data ' +
      'collected for specific jurisdictions where our gaming operations are offered are stored on secure ' +
      'servers within the relevant jurisdiction. This data may also be stored in other jurisdictions ' +
      'where our gaming operations are available, subject to applicable laws. Please note that our servers ' +
      'may not provide the same level of privacy protection as those in other jurisdictions, and we do ' +
      'not claim that our practices comply with laws outside the United States.' +
      '<br><br>Our servers are safeguarded by firewalls and other industry-standard security measures ' +
      'designed to protect against unauthorized access. However, no security system is completely' +
      ' impenetrable, and there is always a risk of a security breach. We have controls in place' +
      ' to detect potential data breaches, contain and minimize data loss, and conduct forensic investigations ' +
      'if a breach occurs.' +
      '<br><br>Our staff is trained to take reasonable measures to ensure that unauthorized individuals ' +
      'cannot access your personal information. Employees who violate our privacy policies are subject ' +
      'to disciplinary action, up to and including termination of employment.' +
      '<br><br>While we take measures to secure our servers, we cannot control the security of the devices or ' +
      'communication methods you use to contact us. It is your responsibility to ensure that your devices ' +
      'and communication methods provide adequate security for interacting with us. We are not responsible ' +
      'for the interception or disclosure of information sent to us before we receive it.' +
      '<br><br>As a standard security practice, we take reasonable steps recognized in the industry ' +
      'to ensure that our communication methods do not permit connections or communications through ' +
      'insecure methods. If you experience difficulties using our services, it may be an indication ' +
      'that you need to upgrade your internet browsing tool or application to a newer version that' +
      ' supports more secure communication methods.<br><br>When third parties collect personal information ' +
      'under contract with us to perform their duties, we require them to exercise reasonable care to ' +
      'protect your information and restrict its use to the purposes for which it was provided. ' +
      'Similarly, when we share your personal information with MaxQuest affiliates or other ' +
      'third parties in accordance with this policy, we require them to exercise reasonable ' +
      'care to protect your information and restrict its use to the intended purposes.'
  },
  {
    title: 'ACCESS TO AND DELETION OF PERSONAL INFORMATION AT MAXQUEST',
    text1: '<strong>Wagering Account Personal Information</strong>' +
      '<br><br>At MaxQuest, we retain personal information associated ' +
      'with your wagering account ("Wagering Account Personal Information") ' +
      'as long as your account remains active. Upon termination of your ' +
      'wagering account, we will continue to retain the relevant personal information ' +
      'for as long as necessary to comply with legal and regulatory obligations, ' +
      'resolve disputes, manage our business, and enforce contractual agreements. ' +
      'Once it is determined that we no longer need to retain such information, ' +
      'in accordance with applicable laws, we will securely erase all Wagering ' +
      'Account Personal Information from hard disks, magnetic tapes, solid-state ' +
      'memory, and other devices before disposing of the devices properly. If ' +
      'erasure is not possible, the device will be destroyed.' +
      '<br><br>If your Wagering Account Personal Information has not been erased or destroyed, ' +
      'you have the right to access, update, and correct inaccuracies in the information we hold. ' +
      'You can update your email address and phone number by logging into your MaxQuest ' +
      'account and making the necessary changes. For all other personal information updates, ' +
      'please contact our customer support team via Live Help, or Discord.' +
      '<br><br><strong>Other Personal Information</strong>' +
      '<br><br>For all other personal information collected in connection with our services, we retain ' +
      'this information as long as necessary to fulfill the purposes for which it was collected, comply ' +
      'with legal and regulatory obligations, resolve disputes, manage our business, and enforce ' +
      'contractual agreements. Once it is determined that retention is no longer necessary, ' +
      'we will securely erase the information from hard disks, magnetic tapes, solid-state ' +
      'memory, and other devices, or we will aggregate, anonymize, or otherwise de-identify ' +
      'the information so that it no longer identifies you.' +
      '<br><br><strong>Additional Information</strong>' +
      '<br><br>If you have any questions or need further assistance with your personal information, please contact our customer support team via Live Help or Discord.'
  },
  {
    title: 'OTHER WEBSITES',
    text1: 'MaxQuest is not responsible for the information collection or privacy practices of other websites, including those that may be accessible through our services. We strongly recommend that you review and understand the privacy policies of any linked sites you visit before using them or providing any personal information.'
  },
  {
    title: 'INTERNATIONAL TRANSFERS',
    text1: 'Information collected through MaxQuest may be stored and processed in any country where we, our affiliates, suppliers, third-party payment processors, or financial institutions maintain facilities. By using our services, you expressly consent to the transfer of your information outside of your country, including to countries that may not have adequate privacy laws. However, we take steps to ensure that our agents, affiliates, and suppliers adhere to our privacy standards regardless of their location.'
  },
  {
    title: 'CHANGES TO THIS POLICY',
    text1: 'MaxQuest may update this Privacy Policy at our discretion. If we make significant changes, we will inform you by placing a notice on our platform, sending you an email, or through other legally permissible methods of communication.'
  }
]